<template>
  <v-responsive
    class="bookmark-thumbnail pos-relative rounded" :class="colors"
    :aspect-ratio="aspectRatio" v-bind="$attrs"
  >
    <BrandImage :src="src" :alt="bookmark.title" class="bookmark-image" />
    <!-- A video: a play badge, and its length once the stream knows it -->
    <template v-if="bookmark.isVideo">
      <span class="video-badge" aria-hidden="true"><PhPlay weight="fill" /></span>
      <span v-if="bookmark.durationLabel" class="video-duration text-caption">{{ bookmark.durationLabel }}</span>
    </template>
    <slot />
  </v-responsive>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { PhPlay } from '@phosphor-icons/vue'
import { THUMBNAIL_ASPECT_RATIO } from '@/utils/constants'

// Vue 3 script setup - inheritAttrs: false
const props = defineProps({
  bookmark: {
    type: Object,
    required: true,
  },
  // width / height; a tier list card keeps an upload's original ratio with it
  aspectRatio: {
    type: Number,
    default: THUMBNAIL_ASPECT_RATIO,
  },
})

// The CDN thumbnail is a 16:9 crop. A box of another ratio loads the whole image,
// so `cover` crops it once to the box instead of cropping the crop.
const src = computed(() => (props.aspectRatio === THUMBNAIL_ASPECT_RATIO
  ? props.bookmark.thumbnailUrl
  : props.bookmark.uncroppedThumbnailUrl))

const colors = computed(() => {
  if (props.bookmark.image) return 'neutral25'
  return props.bookmark.colorClasses
})
</script>

<script>
// Using normal script block to set options
export default {
  inheritAttrs: false
}
</script>

<style lang="scss" scoped>
.placeholder-svg {
  @include overlay;
}

.bookmark-image {
  @include overlay;
}

.video-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 18px;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.video-duration {
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 0 6px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  line-height: 20px;
  pointer-events: none;
}
</style>
